<template>
    <div v-if="info.length != 0">

        <div class="MatchDetailCard__heading">{{roundDisplay(info.stat.rnd)}} &bull; {{type}} &bull; {{isQualifying()}}</div>

        <div class="MatchDetailCard__status">{{matchStatus()}}</div>

        <div class="MatchDetailCard">

            <div class="Match__holder" :class="{ 'Match__holder--small': isDoubles(info.stat.isDoubles) }">

                <div class="Match">

                    <div class="Match__body">
                        <div class="Match__line" :class="{ 'Match__line--winner': winner(info.stat.winner , 'a') }">

                            <div class="Match__player__holder">

                                <div class="Match__player">

                                    <img class="small-flag" :src="getFlagPath(info.stat.cA)"
                                         :alt="info.stat.cA || ''">

                                    <span class="Match__player__fn">{{info.stat.nAF}}</span><span class="Match__player__i">{{initial(info.stat.nAF)}}</span>&nbsp;<span
                                        class="Match__player__ln">{{info.stat.nAL}}</span>
                                    <span class="Match__player__seed"
                                          v-if="info.stat.seedA">[{{info.stat.seedA}}]</span>
                                    <span class="Match__player__seed"
                                          v-if="showType( 'q', info.stat.idA )">[Q]</span>
                                    <span class="Match__player__seed"
                                          v-if="showType( 'wc', info.stat.idA )">[WC]</span>

                                </div>

                                <div class="Match__player" v-if="info.stat.isDoubles == 1">

                                    <img class="small-flag" :src="getFlagPath(info.stat.cA2)"
                                         :alt="info.stat.cA2 || ''">

                                    <span class="Match__player__fn">{{info.stat.nA2F}}</span><span class="Match__player__i">{{initial(info.stat.nA2F)}}</span>&nbsp;<span
                                        class="Match__player__ln">{{info.stat.nA2L}}</span>
                                    <span class="Match__player__seed"
                                          v-if="info.stat.seedA">[{{info.stat.seedA}}]</span>
                                    <span class="Match__player__seed"
                                          v-if="showType( 'q', info.stat.idA2 )">[Q]</span>
                                    <span class="Match__player__seed"
                                          v-if="showType( 'wc', info.stat.idA2 )">[WC]</span>
                                </div>

                            </div>

                            <div v-if="info.stat.serve == '0' || info.stat.serve == '2'"
                                 class="Match__serve" v-html="ico_ball">
                            </div>

                            <div v-if="winner(info.stat.winner , 'a')"
                                 class="Match__winner" v-html="ico_winner"></div>

                            <div class="Match__set">

                                <ul>
                                    <li class="Match__set__pt" v-if="info.stat.ptA">{{info.stat.ptA}}</li>
                                    <li v-if="info.stat">
                                        {{info.stat.s1A}}<sup v-if="info.stat.s1A < info.stat.s1B">{{info.stat.tb1}}</sup>
                                    </li>
                                    <li v-if="info.stat.s2A">
                                        {{info.stat.s2A}}<sup v-if="info.stat.s2A < info.stat.s2B">{{info.stat.tb2}}</sup>
                                    </li>
                                    <li v-if="info.stat.s3A">
                                        {{info.stat.s3A}}<sup v-if="info.stat.s3A < info.stat.s3B">{{info.stat.tb3}}</sup>
                                    </li>
                                </ul>

                            </div>

                        </div>

                        <div class="Match__line" :class="{ 'Match__line--winner': winner(info.stat.winner , 'b') }">

                            <div class="Match__player__holder">

                                <div class="Match__player">

                                    <img class="small-flag" :src="getFlagPath(info.stat.cB)"
                                         :alt="info.stat.cB || ''">

                                    <span class="Match__player__fn">{{info.stat.nBF}}</span><span class="Match__player__i">{{initial(info.stat.nBF)}}</span>&nbsp;<span
                                        class="Match__player__ln">{{info.stat.nBL}}</span>
                                    <span class="Match__player__seed"
                                          v-if="info.stat.seedB">[{{info.stat.seedB}}]</span>
                                    <span class="Match__player__seed"
                                          v-if="showType( 'q', info.stat.idB )">[Q]</span>
                                    <span class="Match__player__seed"
                                          v-if="showType( 'wc', info.stat.idB )">[WC]</span>

                                </div>

                                <div class="Match__player" v-if="info.stat.isDoubles == 1">

                                    <img class="small-flag" :src="getFlagPath(info.stat.cB2)"
                                         :alt="info.stat.cB2 || ''">

                                    <span class="Match__player__fn">{{info.stat.nB2F}}</span><span class="Match__player__i">{{initial(info.stat.nB2F)}}</span>&nbsp;<span
                                        class="Match__player__ln">{{info.stat.nB2L}}</span>
                                    <span class="Match__player__seed"
                                          v-if="info.stat.seedB">[{{info.stat.seedB}}]</span>
                                    <span class="Match__player__seed"
                                          v-if="showType( 'q', info.stat.idB2 )">[Q]</span>
                                    <span class="Match__player__seed"
                                          v-if="showType( 'wc', info.stat.idB2 )">[WC]</span>

                                </div>

                            </div>

                            <div v-if="info.stat.serve == '1' || info.stat.serve == '3'"
                                 class="Match__serve" v-html="ico_ball">
                            </div>

                            <div v-if="winner(info.stat.winner , 'b')"
                                 class="Match__winner" v-html="ico_winner"></div>

                            <div class="Match__set">

                                <ul>

                                    <li class="Match__set__pt" v-if="info.stat.ptB">{{info.stat.ptB}}</li>
                                    <li v-if="info.stat.s1B">
                                        {{info.stat.s1B}}<sup v-if="info.stat.s1A > info.stat.s1B">{{info.stat.tb1}}</sup>
                                    </li>
                                    <li v-if="info.stat.s2B">
                                        {{info.stat.s2B}}<sup v-if="info.stat.s2A > info.stat.s2B">{{info.stat.tb2}}</sup>
                                    </li>
                                    <li v-if="info.stat.s3B">
                                        {{info.stat.s3B}}<sup v-if="info.stat.s3A > info.stat.s3B">{{info.stat.tb3}}</sup>
                                    </li>

                                </ul>

                            </div>

                        </div>

                        <div class="Match__meta">

                            <div class="Match__time" :class="{ full: info.stat.state == 'F' }">
                                <span v-html="ico_clock"></span>
                                {{matchTime(info.stat.mt)}}
                            </div>

                            <div class="Match__msg" v-if="messageFormat(info.stat) && info.stat.state != 'F'">
                                <span v-html="messageFormat(info.stat)"></span>
                            </div>

                        </div>
                    </div>

                </div>

            </div>

            <div class="MatchDetailFigure__holder">

                <div class="MatchDetailFigure__team">
                    <div class="MatchDetailFigure__team__holder" :class="{ 'MatchDetailFigure__team__holder--doubles': isDoubles(info.stat.isDoubles) }">
                        <player-figure :player="info.stat.idA" :assoc="assoc"></player-figure>
                        <player-figure v-if="info.stat.idA2.length > 0":player="info.stat.idA2" :assoc="assoc"></player-figure>
                    </div>
                </div>

                <div class="MatchDetailFigure__team">
                    <div class="MatchDetailFigure__team__holder--right" :class="{ 'MatchDetailFigure__team__holder--doubles': isDoubles(info.stat.isDoubles) }">
                        <player-figure :player="info.stat.idB" :assoc="assoc"></player-figure>
                        <player-figure v-if="info.stat.idB2.length > 0" :player="info.stat.idB2" :assoc="assoc"></player-figure>
                    </div>
                </div>
            </div>

        </div>

        <player-name :match="match" :assoc="assoc" :info="info.stat"></player-name>

        <div class="MatchDetail__stat">

            <div class="stat-line__holder">

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{aces(0)[1]}}</div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value" :style="{ width: aces(0)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        aces
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{aces(1)[1]}}</div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse" :style="{ width: aces(1)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{double_faults(0)[1]}}</div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value" :style="{ width: double_faults(0)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        double faults
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{double_faults(1)[1]}}</div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse" :style="{ width: double_faults(1)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{first_serve_percentage(0)[0]}}%
                            <span>({{first_serve_percentage(0)[1]}}/{{first_serve_percentage(0)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value"
                                 :style="{ width: first_serve_percentage(0)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        1st serve
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{first_serve_percentage(1)[0]}}%
                            <span>({{first_serve_percentage(1)[1]}}/{{first_serve_percentage(1)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: first_serve_percentage(1)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{first_serve_points_won(0)[0]}}%
                            <span>({{first_serve_points_won(0)[1]}}/{{first_serve_points_won(0)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value"
                                 :style="{ width: first_serve_points_won(0)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        1st serve points won
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{first_serve_points_won(1)[0]}}%
                            <span>({{first_serve_points_won(1)[1]}}/{{first_serve_points_won(1)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: first_serve_points_won(1)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{second_serve_points_won(0)[0]}}%
                            <span>({{second_serve_points_won(0)[1]}}/{{second_serve_points_won(0)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value"
                                 :style="{ width: second_serve_points_won(0)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        2nd serve points won
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{second_serve_points_won(1)[0]}}%
                            <span>({{second_serve_points_won(1)[1]}}/{{second_serve_points_won(1)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: second_serve_points_won(1)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{break_points_saved(1)[0]}}%
                            <span>({{break_points_saved(1)[1]}}/{{break_points_saved(1)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value"
                                 :style="{ width: break_points_saved(1)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        break points saved
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{break_points_saved(0)[0]}}%
                            <span>({{break_points_saved(0)[1]}}/{{break_points_saved(0)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: break_points_saved(0)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{service_games_played(0)[1]}}</div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value"
                                 :style="{ width: service_games_played(0)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        service games played
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{service_games_played(1)[1]}}</div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: service_games_played(1)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{first_return_points_won(1)[0]}}%
                            <span>({{first_return_points_won(1)[1]}}/{{first_return_points_won(1)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value"
                                 :style="{ width: first_return_points_won(1)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        1st return points won
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{first_return_points_won(0)[0]}}%
                            <span>({{first_return_points_won(0)[1]}}/{{first_return_points_won(0)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: first_return_points_won(0)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{second_return_points_won(1)[0]}}%
                            <span>({{second_return_points_won(1)[1]}}/{{second_return_points_won(1)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value "
                                 :style="{ width: second_return_points_won(1)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        2nd return points won
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{second_return_points_won(0)[0]}}%
                            <span>({{second_return_points_won(0)[1]}}/{{second_return_points_won(0)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: second_return_points_won(0)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{break_points_won(0)[0]}}%
                            <span>({{break_points_won(0)[1]}}/{{break_points_won(0)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value"
                                 :style="{ width: break_points_won(0)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        break points won
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{break_points_won(1)[0]}}%
                            <span>({{break_points_won(1)[1]}}/{{break_points_won(1)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: break_points_won(1)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{return_games_played(1)[1]}}</div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value"
                                 :style="{ width: return_games_played(1)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        return games played
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{return_games_played(0)[1]}}</div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: return_games_played(0)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{total_service_points_won(0)[0]}}%
                            <span>({{total_service_points_won(0)[1]}}/{{total_service_points_won(0)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value"
                                 :style="{ width: total_service_points_won(0)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        total service points won
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{total_service_points_won(1)[0]}}%
                            <span>({{total_service_points_won(1)[1]}}/{{total_service_points_won(1)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: total_service_points_won(1)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>
                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{total_return_points_won(1)[0]}}%
                            <span>({{total_return_points_won(1)[1]}}/{{total_return_points_won(1)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value"
                                 :style="{ width: total_return_points_won(1)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        total return points won
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{total_return_points_won(0)[0]}}%
                            <span>({{total_return_points_won(0)[1]}}/{{total_return_points_won(0)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: total_return_points_won(0)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>
                <div class="stat-line">
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{total_points_won(0, 1)[0]}}% <span>({{total_points_won(0,
                        1)[1]}}/{{total_points_won(0, 1)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value"
                                 :style="{ width: total_points_won(0, 1)[0] + '%' }"></div>
                        </div>
                    </div>
                    <div class="stat-line__info">
                        total points won
                    </div>
                    <div class="stat-line__player">
                        <div class="stat-line__value">{{total_points_won(1, 0)[0]}}% <span>({{total_points_won(1,
                        0)[1]}}/{{total_points_won(1, 0)[2]}})</span>
                        </div>
                        <div class="stat-line__percent">
                            <div class="stat-line__percent__value stat-line__percent__reverse"
                                 :style="{ width: total_points_won(1, 0)[0] + '%' }"></div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import MatchDetailFigure from './MatchDetailFigure'
    import MatchDetailDetail from './MatchDetailPlayer'

    export default {
        components: {
            'player-figure': MatchDetailFigure,
            'player-name': MatchDetailDetail
        },
        props: ['match', 'assoc', 'flag', 'tournament'],
        data() {
            return {
                info              : [],
                setInfo           : [],
                feed              : [],
                ico_winner        : window.ico_tick,
                ico_pointer_right : window.ico_pointer_right,
                ico_ball          : window.ico_ball,
                ico_clock         : window.ico_clock,
                flagPath          : this.flag + '/assets/dist/svg/flags/',
                tournament_slug   : this.tournament,
                type              : this.assoc,
                players           : window.all_players
            }
        },
        created() {
            this.getFeed()

            let app = this
            setInterval(function () {
                app.getFeed()
            }, 15 * 1000, app)
        },
        methods: {
            matchStatus() {
                if (this.info.stat.state == 'F') {
                    return 'Finished'
                }

                if (this.info.stat.state == 'P') {
                    return 'In Progress'
                }

                if (this.info.stat.state == 'M') {
                    return 'In Progress'
                }

                if (this.info.stat.state == 'W') {
                    return 'Warmup'
                }

                if (this.info.stat.state == 'C') {
                    return 'On court'
                }

                if (this.info.stat.state == 'S') {
                    return 'Suspended'
                }

                if (match.detail.state == 'G') {
                    return 'Players Arrived'
                }

                if (match.detail.state == 'T') {
                    return 'Time Announcement'
                }

                return this.info.stat.state
            },
            winner(winner, team) {
                 if (team == 'a' && (winner == '2' || winner == '4' || winner == '6')) {
                    return true
                }
                if(team == 'a' && winner != '' && (winner == this.info.stat.idA  )) {
                    return true
                }

                if (team == 'b' && (winner == '3' || winner == '5' || winner == '7')) {
                    return true
                }
                if(team == 'b' && winner != '' && (winner== this.info.stat.idB )) {
                    return true
                }


                return false
            },
            isDoubles(winner) {
                if ( winner == '1' )
                    return true;

                return false
            },
            isQualifying() {
                if ( this.info.stat.isQuals == '1' )
                    return 'qualifying'
                else
                    return 'main draw'
            },
            roundDisplay(round) {
                if (round == '1' || round == 'R32' || round == 'First Round')
                    return 'Round 1'
                else if (round == '2' || round == 'R16' || round == 'Second Round')
                    return 'Round 2'

                if (this.type == 'wta') {
                    if (round == 'Q')
                        return 'Quarterfinals'
                    else if (round == 'S')
                        return 'Semifinals'
                    else if (round == 'F')
                        return 'Final'
                } else {
                    if (round == '5')
                        return 'Quarterfinals'
                    else if (round == '6')
                        return 'Semifinals'
                    else if (round == '7')
                        return 'Final'
                }

                if ( round == 'Q1' || round == 'R1' )
                    return 'Round 1'
                else if ( round == 'Q2' || round == 'R2' || round == "Q4" )
                    return 'Round 2'

                return round;
            },
            courtDisplay(courtId) {

                let courts = window.court_stadium

                courts = courts.filter(function(court) {
                    return court.court_id == courtId
                })

                if ( courts.length > 0 ) {
                    return courts[0].stadium_name
                }

                return courtId

            },
            matchTime(time) {
                if (time.length < 6) {
                    return time + ':00'
                }

                return time
            },
            messageFormat(detail) {

                if (detail.msg == '') {
                    return ''
                }

                let messages = detail.msg.match(/{(.*?)}/)
                let messageParts = messages[0].slice(1, -1).split('|')

                if (messageParts[0] == '1') {
                    return 'Match point'
                }

                if (messageParts[0] == '2') {
                    return `${messageParts[1]} match points`
                }

                if (messageParts[0] == '3') {
                    return 'Break point'
                }

                if (messageParts[0] == '4') {
                    return `${messageParts[1]} break points`
                }

                if (messageParts[0] == '5') {
                    return 'Set point'
                }

                if (messageParts[0] == '6') {
                    return `${messageParts[1]} set points`
                }

                if (messageParts[0] == '7') {
                    return '2nd serve'
                }

                if (messageParts[0] == '8') {
                    return `Double fault #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '9') {
                    return `Ace  - ${messageParts[1]} for ${messageParts[2]}`
                }
                if (messageParts[0] == '10') {
                    return `Ace on 2nd serve – ace #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '11') {
                    return ''
                    return `Winner: ${messageParts[1]}`
                }

                if (messageParts[0] == '12') {
                    return ''
                    return `Winners ${messageParts[1]}`
                }

                if (messageParts[0] == '13') {
                    return `Double fault ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '14') {
                    return `Ace ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '15') {
                    return `Ace on 2nd serve ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '16') {
                    return 'Match suspended – rain'
                }

                if (messageParts[0] == '17') {
                    return 'Match suspended – darkness'
                }

                if (messageParts[0] == '18') {
                    return 'Match suspended – heat'
                }

                if (messageParts[0] == '19') {
                    return 'Match suspended'
                }

                if (messageParts[0] == '20') {
                    return 'by retirement'
                }

                if (messageParts[0] == '21') {
                    return `Point penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '22') {
                    return `Game penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '23') {
                    return `Time penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '24') {
                    return 'by default'
                }

                if (messageParts[0] == '25') {
                    return 'Game point'
                }

                if (messageParts[0] == '26') {
                    return `${messageParts[1]} game points`
                }

                if (messageParts[0] == '27') {
                    return 'Foot fault – 2nd serve'
                }

                if (messageParts[0] == '28') {
                    return `Foot fault – Double fault #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '29') {
                    return `Foot fault – Double fault ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '30') {
                    return 'Let'
                }

                return ''

            },
            getFeed() {

                axios.get(`${window.feed_ip}/get/${this.assoc}/${this.tournament_slug}/${this.match}`).then(response => {


                    this.feed = response.data
                    this.info = response.data

                    if(this.info.stat.isDoubles == "" && this.feed.id.substring(0, 2) == "MD"){
                        this.info.stat.isDoubles = 1;
                    }

                    // Would be nice to refactor this… nevertheless it works
                    let setInfo = []

                    if (response.data.length != 0) {
                        setInfo.push(...response.data.s1)
                        setInfo.push(...response.data.s2)
                        setInfo.push(...response.data.s3)

                        for (let sv in setInfo[2]) {

                            setInfo[0][sv] = parseInt(setInfo[0][sv]) + parseInt(setInfo[2][sv])

                        }

                        for (let sv in setInfo[3]) {

                            setInfo[1][sv] = parseInt(setInfo[1][sv]) + parseInt(setInfo[3][sv])

                        }

                        if (setInfo[4]) {

                            for (let sv in setInfo[4]) {

                                setInfo[0][sv] = parseInt(setInfo[0][sv]) + parseInt(setInfo[4][sv])

                            }

                        }

                        for (let sv in setInfo[5]) {

                            setInfo[1][sv] = parseInt(setInfo[1][sv]) + parseInt(setInfo[5][sv])

                        }

                        this.setInfo = setInfo
                    }
                }).catch(function (error) {
                    console.log(error);
                });

            },
            findPlayerById(playerId) {
                if ( playerId == '' )
                    return false

                let found = this.players.filter(player => player.player_id == playerId)

                if (found.length >= 1)
                    return found[0]

                return false
            },
            showType( type, playerId ) {
                let player = this.findPlayerById( playerId )

                if ( type == 'wc' && player.iswildcard == '1' )
                    return true
                else if ( type == 'q' && player.isqualifier == '1' )
                    return true

                return false;
            },
            initial(name) {
                return `${name.charAt(0)}.`
            },
            aces(team) {

                let percent = 0
                let total = parseInt(this.setInfo[0].aces) + parseInt(this.setInfo[1].aces)

                if (total > 0) {
                    percent = Math.round((parseInt(this.setInfo[team].aces) / total) * 100)
                }

                return [percent, parseInt(this.setInfo[team].aces)]

            },
            double_faults(team) {

                let percent = 0
                let total = parseInt(parseInt(this.setInfo[0].dbl_flt)) + parseInt(parseInt(this.setInfo[1].dbl_flt))

                if (total > 0) {
                    percent = Math.round((parseInt(this.setInfo[team].dbl_flt) / total) * 100)
                }

                return [percent, parseInt(this.setInfo[team].dbl_flt)]

            },
            first_serve_percentage(team) {

                if (parseInt(this.setInfo[team].tot_serv) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((parseInt(this.setInfo[team].good_1st_serv) / parseInt(this.setInfo[team].tot_serv)) * 100),
                    parseInt(this.setInfo[team].good_1st_serv),
                    parseInt(this.setInfo[team].tot_serv)
                ]

            },
            first_serve_points_won(team) {

                if (parseInt(this.setInfo[team].tot_serv) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((parseInt(this.setInfo[team].pts_1st_serv) / parseInt(this.setInfo[team].good_1st_serv)) * 100),
                    parseInt(this.setInfo[team].pts_1st_serv),
                    parseInt(this.setInfo[team].good_1st_serv)
                ]

            },
            second_serve_points_won(team) {

                if ((parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv)) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round(((parseInt(this.setInfo[team].pts_to_serv) - parseInt(this.setInfo[team].pts_1st_serv)) / (parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv))) * 100),
                    (parseInt(this.setInfo[team].pts_to_serv) - parseInt(this.setInfo[team].pts_1st_serv)),
                    (parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv))
                ]

            },
            break_points_saved(team) {

                if (parseInt(this.setInfo[team].break_pts) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round(((parseInt(this.setInfo[team].break_pts) - parseInt(this.setInfo[team].break_n)) / parseInt(this.setInfo[team].break_pts)) * 100),
                    (parseInt(this.setInfo[team].break_pts) - parseInt(this.setInfo[team].break_n)),
                    parseInt(this.setInfo[team].break_pts)
                ]

            },
            service_games_played(team) {

                let percent = 0
                let total = parseInt(parseInt(this.setInfo[0].sgPlayed)) + parseInt(parseInt(this.setInfo[1].sgPlayed))

                if (total > 0) {
                    percent = Math.round((parseInt(this.setInfo[team].sgPlayed) / total) * 100)
                }

                return [percent, parseInt(this.setInfo[team].sgPlayed)]

            },
            first_return_points_won(team) {

                if (parseInt(this.setInfo[team].tot_serv) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round(((parseInt(this.setInfo[team].good_1st_serv) - parseInt(this.setInfo[team].pts_1st_serv)) / parseInt(this.setInfo[team].good_1st_serv)) * 100),
                    (parseInt(this.setInfo[team].good_1st_serv) - parseInt(this.setInfo[team].pts_1st_serv)),
                    parseInt(this.setInfo[team].good_1st_serv)
                ]

            },
            second_return_points_won(team) {

                if ((parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv)) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((((parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv)) - (parseInt(this.setInfo[team].pts_to_serv) - parseInt(this.setInfo[team].pts_1st_serv))) / (parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv))) * 100),
                    ((parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv)) - (parseInt(this.setInfo[team].pts_to_serv) - parseInt(this.setInfo[team].pts_1st_serv))),
                    (parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].good_1st_serv))
                ]

            },
            break_points_won(team) {

                if (parseInt(this.setInfo[team].break_pts) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((parseInt(this.setInfo[team].break_n) / parseInt(this.setInfo[team].break_pts)) * 100),
                    parseInt(this.setInfo[team].break_n),
                    parseInt(this.setInfo[team].break_pts)
                ]

            },
            return_games_played(team) {

                let percent = 0
                let total = parseInt(parseInt(this.setInfo[0].sgPlayed)) + parseInt(parseInt(this.setInfo[1].sgPlayed))

                if (total > 0) {
                    percent = Math.round((parseInt(this.setInfo[team].sgPlayed) / total) * 100)
                }

                return [percent, parseInt(this.setInfo[team].sgPlayed)]

            },
            total_service_points_won(team) {

                if (parseInt(this.setInfo[team].tot_serv) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((parseInt(this.setInfo[team].pts_to_serv) / parseInt(this.setInfo[team].tot_serv)) * 100),
                    parseInt(this.setInfo[team].pts_to_serv),
                    parseInt(this.setInfo[team].tot_serv)
                ]

            },
            total_return_points_won(team) {

                if (parseInt(this.setInfo[team].tot_serv) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round(((parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].pts_to_serv)) / parseInt(this.setInfo[team].tot_serv)) * 100),
                    (parseInt(this.setInfo[team].tot_serv) - parseInt(this.setInfo[team].pts_to_serv)),
                    parseInt(this.setInfo[team].tot_serv)
                ]

            },
            total_points_won(teamA, teamB) {

                if(this.setInfo[teamA].tot_pts == '' && this.setInfo[teamB].tot_pts == ''){
                    return ['0', '0', '0']
                }

                if ((parseInt(this.setInfo[teamA].tot_pts) + parseInt(this.setInfo[teamB].tot_pts)) == '0') {
                    return ['0', '0', '0']
                }

                return [
                    Math.round((parseInt(this.setInfo[teamA].tot_pts) / (parseInt(this.setInfo[teamA].tot_pts) + parseInt(this.setInfo[teamB].tot_pts))) * 100),
                    parseInt(this.setInfo[teamA].tot_pts),
                    (parseInt(this.setInfo[teamA].tot_pts) + parseInt(this.setInfo[teamB].tot_pts))
                ]

            },
            getFlagPath(countryCode) {
                if (!countryCode) return this.flagPath + '---.svg';
                return this.flagPath + countryCode.toLowerCase() + '.svg';
            }
        }
    }
</script>
